'use es6';

import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewReportErrorWrapper = ({
  title,
  children
}) => /*#__PURE__*/_jsx(View, {
  blockSize: "100%",
  children: /*#__PURE__*/_jsx(ScrollContainer, {
    marginBlockStart: "300",
    children: /*#__PURE__*/_jsxs(TFlex, {
      direction: "column",
      align: "center",
      children: [title && /*#__PURE__*/_jsx(Text, {
        as: "h5",
        align: "center",
        marginBlockEnd: "400",
        children: title
      }), children]
    })
  })
});
export default ViewReportErrorWrapper;